import type { Moment } from 'moment';
import { CALENDAR_TIME_SET } from 'constants/calendar';
import moment from 'utils/moment';

/**
 * Gio bat dau mac dinh cho booking nhanh.
 *
 * Chi lay gio hien tai (lam tron xuong moc 15') khi ngay dang xem la hom nay va gio do con
 * nam trong khung mo cua; moi truong hop con lai roi ve 9:00 AM cua ngay dang xem — dat lich
 * ngoai gio mo cua khong co y nghia.
 *
 * Ham thuan: ngay dang xem truyen tu ngoai vao (thuong la `dateParamSignal.value`) de khong
 * rang buoc util nay vao cay component cua calendar.
 */
export const getCurrentTimeSlot = (filterDate?: Moment | null): Moment => {
  const baseDate = filterDate || moment();
  const now = moment().add(15, 'minute');
  const nowTime = [0, 15, 30, 45, 60].map(o => ({ key: o, value: (now.get('minute') - o) })).filter(o => o.value >= 0);
  const minute = nowTime.find(o => o.value === Math.min(...nowTime.map(o => o.value)))?.key;

  let startTime = baseDate.clone();
  if (baseDate.isSame(now, 'date')) {
    startTime = moment().set({
      hour: now.get('hour'),
      minute: minute ?? now.get('minute'),
      second: 0,
    });
    const { close, open } = CALENDAR_TIME_SET;
    if (startTime.isBetween(open, close))
      return startTime;
  }
  return startTime.set({ hour: 9, minute: 0, second: 0 });
};
